import React from "react";
import FrameDetailsTable from "./FrameDetailsTable";
import { ImageMetadata } from "../types";

interface FrameTabPanelProps {
  imagesForView: ImageMetadata[];
  frameTypeFilter: string;
  setFrameTypeFilter: (filter: string) => void;
  filterTypeFilter: string;
  setFilterTypeFilter: (filter: string) => void;
}

const FrameTabPanel: React.FC<FrameTabPanelProps> = ({
  imagesForView,
  frameTypeFilter,
  setFrameTypeFilter,
  filterTypeFilter,
  setFilterTypeFilter,
}) => (
  <FrameDetailsTable
    imagesForView={imagesForView}
    frameTypeFilter={frameTypeFilter}
    setFrameTypeFilter={setFrameTypeFilter}
    filterTypeFilter={filterTypeFilter}
    setFilterTypeFilter={setFilterTypeFilter}
  />
);

export default FrameTabPanel;
